import { AiOutlineCloseCircle } from "react-icons/ai";
import Modal from "../../common/Modal";
import { useEffect, useState } from "react";
import { Payment, Reservation } from "../../../types/common.types";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import GeneralInput from "../../common/GeneralInput";
import Dropdown from "../../common/Dropdown";
import FileInput from "../../common/FileInput";
import jsonToFormData from "../../../utils/jsonToFormData";
import { useGlobal } from "../../../context/global";
import styled from "styled-components";
import removeTimezone from "../../../utils/removeTimezone";

// used for traspax
export default function CreatePaymentReservation() {
    const { setMessage } = useGlobal()
    const { createPaymentReservationId, setCreatePaymentReservationId, setCurrentDay } = useAdmin()
    const [ reservation, setReservation ] = useState<Reservation>({} as Reservation)
    const [ data, setData ] = useState<Payment>({} as Payment)

    useEffect(() => {
        async function getInfo() {
            try {
                const response = (await AdminService.getReservation(createPaymentReservationId!)).data
                setReservation(response)
            } catch (error) {
                console.log(error);
            }
        }
        getInfo()
    }, [])

    function onChange(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        setData(prevData => ({
            ...prevData,
            [e.target.name]: e.target.value
        }))
    }

    function onChangeFiles(newFile: File | undefined, name: keyof Payment) {
        console.log(newFile)
        setData(prevData => ({...prevData, [name]: newFile}))
    }

    async function registerPayment(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            const newData = {
                ...data,
                reservation_id: createPaymentReservationId!
            }
            const formData = jsonToFormData(newData)
            await AdminService.registerReservationPayment(formData)
            setMessage({
                type: 'success',
                content: 'Payment registered successfully'
            })
            setTimeout(() => setMessage(undefined), 2500)
            setCreatePaymentReservationId(undefined)
            setCurrentDay((prevDay: Date) => new Date(prevDay)) 
        }
        catch (error) {
            console.log(error);
            setMessage({
                type: 'error',
                content: 'There was an error registering the payment'
            })
            setTimeout(() => setMessage(undefined), 2500)
        }
    }

    return (
        <Modal onSubmit={registerPayment}>
            <h1>Create Payment for Reservation</h1>
            <h2>Payment of {reservation.passenger?.name}</h2>
            <List>
                {
                    reservation.payments &&
                    reservation.payments
                    .map((p, idx) => {
                        return (
                            <div className="payment" key={idx}>
                            <div className="header">
                                <div className="name">
                                    <span>
                                        {removeTimezone(p.created_at.toString())}
                                    </span>
                                </div>
                            </div>
                            <TableWrapper >
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Amount tour</th>
                                            <th>Amount tickets</th>
                                            <th>Payment Method</th>
                                            <th>Remarks</th>
                                            <th>pic</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>${p.amount}</td>
                                            <td>${p.amount_tickets || 0}</td>
                                            <td>{p.payment_method}</td>
                                            <td>{p.remarks}</td>
                                            <td>
                                                {
                                                    p.pic ?
                                                    <div className="img">
                                                        <img crossOrigin="anonymous" src={`${process.env.REACT_APP_API_URL}/files/${p.pic}`} alt="" />
                                                        <a target="_BLANK" href={`${process.env.REACT_APP_API_URL}/files/${p.pic}`}></a>
                                                    </div>
                                                    : 'No image'
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </TableWrapper>
                            </div>
                        )
                    })
                }
            </List>
            <GeneralInput
            label="Pagado de tour"
            name="amount"
            type="number"
            value={data.amount || ''}
            placeholder="10.000"
            onChange={onChange}
            required
            />
            <GeneralInput
            label="Pagado de entradas"
            name="amount_tickets"
            type="number"
            value={data.amount_tickets || ''}
            placeholder="5.000"
            onChange={onChange}
            required
            style={{margin: '20px 0'}}
            />
            <GeneralInput
            label="Remarks"
            onChange={onChange}
            required
            name="remarks"
            style={{margin: '20px 0'}}
            />
            <div className="payment">
                <h2>Payment method</h2>
                <h3>{data.payment_method}</h3>
                <Dropdown
                title="Payment method"
                options={['transfer', 'cash']}
                onSelect={(newValue: string) => setData(prevData => ({...prevData, payment_method: newValue}))}
                />
            </div>
            <FileInput
            style={{margin: '10px 0'}}
            value={data.pic}
            deleteFile={() => onChangeFiles(undefined, 'pic')}
            accept=".png, .jpg, .jpeg, .heic"
            onChange={(newFile: File) => onChangeFiles(newFile, 'pic')}
            />
            <div className="actions" style={{display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px'}}>
                <button style={{backgroundColor: 'green', color: 'white', border: 'none'}}
                >Create Payment</button>
                <button type="button" style={{backgroundColor: 'gray', color: 'white', border: 'none'}}
                onClick={() => setCreatePaymentReservationId(undefined)}
                >Cancel</button>
            </div>
            <div className="close"
            onClick={() => setCreatePaymentReservationId(undefined)}
            >
                <AiOutlineCloseCircle />
            </div>
        </Modal>
    )
}

const List = styled.div`
width: 100%;
max-height: 300px;
overflow: hidden;
overflow-y: auto;
margin: 20px 0;
.payment {
    background-color: ${props => props.theme.whiteBackground};
    border-radius: 10px;
    box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
    margin-bottom: 20px;
    .header {
        display: flex;
        align-items: center;
        position: relative;
        justify-content: center;
        border-radius: 10px 10px 0 0;
        height: 40px;
        gap: 10px;
        background-color: ${props => props.theme.black};
        color: ${props => props.theme.white};
        .name {
            flex: 1;
            text-align: center;
            display: flex;
            gap: 10px;
            justify-content: center;
            text-transform: capitalize;
        }
    }
}
`

const TableWrapper = styled.div`
width: 100%;
height: 100%;
overflow: hidden;
overflow-x: unset;
`

const Table = styled.table`
border-collapse: collapse;
table-layout: fixed;
height: 100%;
position: relative;
width: 100%;
min-width: 400px;
overflow: hidden;
thead {
    width: 100%;
    background-color: #FFFFFF;
}
th {
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
}
td {
    text-align: center;
    height: 100px;
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        border: none;
        background-color: ${props => props.theme.blueLight};
        color: ${props => props.theme.white};
        cursor: pointer;
    }
    .img {
        width: 100%;
        position: relative;
        img {
            width: 100%;
        }
        a {
            width: 100%;
            height: 100%;
            display: block;
            position: absolute;
            z-index: 10;
            top: 0;
            left: 0;
        }
        padding: 10px;
    }
}
tr {
    height: 40px;
    width: 100%;
}
`